// extracted by mini-css-extract-plugin
module.exports = {"dot":"styles_dot__6s_ie"};